import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import buildStore from '../../Lib/redux/store';
import Form from '../Form/Form';
import ThemeProvider from '../ThemeProvider/ThemeProvider';
import { client } from '../../Services/Gateway/Apollo';

const Widget = ({ formSettings }) => {
  const store = React.useMemo(() => buildStore(formSettings), []);

  return (
    <ReduxProvider store={store}>
      <ApolloProvider client={client}>
        <ThemeProvider>
          <Form />
        </ThemeProvider>
      </ApolloProvider>
    </ReduxProvider>
  );
};

export default Widget;
